import appConfig from '../../config/app';
import { getAuthHeaders } from '../fetchers/auth';

export async function deleteNewsPost(gymUid, postId) {
  const options = await getAuthHeaders();

  const response = await fetch(
    `${appConfig.baseApiUrl}/api/v1/gyms/${gymUid}/news_posts/${postId}`,
    {
      method: 'DELETE',
      headers: {
        ...options,
      },
    }
  );

  if (!response.ok) {
    const errorPayload = await response.json().catch(() => null);
    throw new Error(errorPayload?.error || 'Unable to delete post');
  }

  return true;
}
